import type { AxiosResponse } from 'axios';
import axios from 'axios';

export interface MonitoringInfo {
  app?: {
    name: string;
    version: string;
    java: {
      version: string;
    };
  };
}

export interface MonitoringHealth {
  status?: string;
  components?: {
    diskSpace: {
      status: string;
      details: {
        total: number;
        free: number;
        threshold: number;
      };
    };
    ping: {
      status: string;
    };
  };
}

export default {
  getMonitoringInfo: (): Promise<AxiosResponse<MonitoringInfo>> =>
    axios.get<MonitoringInfo>(`/monitoring/info`),

  getMonitoringHealth: (): Promise<AxiosResponse<MonitoringHealth>> =>
    axios.get<MonitoringHealth>(`/monitoring/health`)
};
